import { Services, getApi, getFetchOptions, getUrl, vicciGetDataversionUpdateHandler as defaultDataversionUpdateHandler, } from '@volkswagen-onehub/library-services-common';
export async function fetchStartConfiguration(serviceConfig, mockConfig, tenantDataVersion, tenant, configuration, options, dataversionUpdateHandler = defaultDataversionUpdateHandler) {
    const { carlineId, salesGroupId, trimName, modelId, modelYear, modelVersion, } = configuration;
    const queryParams = Object.assign({ tenant,
        tenantDataVersion, carlineKey: carlineId, salesgroupKey: salesGroupId, 
        // trimName and modelId can't be specified at the same time. The more specific (modelId) wins
        trimName: modelId ? undefined : trimName, modelKey: modelId, modelYear,
        modelVersion }, options);
    const url = getUrl(serviceConfig, mockConfig, '/startConfiguration', queryParams);
    return dataversionUpdateHandler(getApi, url, Services.VICCI_VCS_START_CONFIGURATION, getFetchOptions(serviceConfig, mockConfig));
}
